export default "<p>\r\n  You are Authorized\r\n</p>\r\n";